import DateView from 'components/formatter/DateView';
import { useAuth } from 'context/AuthProvider';
import { useState, useEffect } from 'react';
function MyClock() {
    const [date, setDate] = useState(new Date());
    const { logout, isRefreshTokenExpired } = useAuth();

    function refreshClock() {
        setDate(new Date());
        if (isRefreshTokenExpired()) {
            logout()
        }
    }
    useEffect(() => {
        const timerId = setInterval(refreshClock, 1000);
        return function cleanup() {
            clearInterval(timerId);
        };
    }, []);
    return (
        <span>
            <DateView val={date} />,&nbsp;{date.toLocaleTimeString()}
        </span>
    );
}
export default MyClock;